import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '../../components/Button';
import CoursePageForm from '../../components/CoursePage/CoursePageForm';
import BreadCrumb from '../../components/Breadcrumb';
import * as actions from '../../redux/actions/actions-coursepage';

class addCoursePage extends Component {
  constructor(props) {
    super(props);

    if (props.match.params.id !== '0') {
      props.setForm(props.match.params.id);
    } else {
      props.resetForm();
    }
    this.state = {};
    props.getTestimonial();
  }


  handleSubmit = (FormData) => {
    this.props.saveCoursePage(FormData);
  }

  render() {
    return (
      <>
        <div className="container">
          <BreadCrumb currentPage="Course Page" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    { this.props.match.params.id !== '0'
                      ? <span className="fa fa-pencil-alt cardTitle"> Edit CoursePage</span>
                      : <span className="fa fa-plus-square cardTitle"> Create New CoursePage</span>}
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.goBack()}
                    >
                      <span className="fa fa-arrow-left" />
                      {' '}
                      Back
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">
                {/* <h3>fnkbfgjbfgb</h3> */}
                <CoursePageForm
                  onSubmit={this.handleSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

addCoursePage.propTypes = {
  formLoading: PropTypes.bool,
  formError: PropTypes.string,
  saveCoursePage: PropTypes.func,
  getTestimonial: PropTypes.func.isRequired
};

addCoursePage.defaultProps = {
  formLoading: null,
  formError: null,
  saveCoursePage: null
};

const mapStateToProps = ({ coursePage }) => ({});


const mapDispatchToProps = (dispatch) => ({
  getTestimonial: () => dispatch(actions.fetchTestimonial()),
  saveCoursePage: (data) => dispatch(actions.saveCoursePage(data)),
  setForm: (id) => dispatch(actions.editCoursePage(id)),
  resetForm: () => dispatch(actions.resetForm())
});

export default connect(mapStateToProps, mapDispatchToProps)(addCoursePage);
